<template lang="html">
  <v-card class="my-0 py-0 mx-0 mb-6" elevation="4" min-height="110" :height="fullheight">
    <v-card-title class="text-h6 font-weight-bold">
      {{ title }}
    </v-card-title>
    <v-card-subtitle class="pb-0">
      {{ subtitle }}
    </v-card-subtitle>
    <!-- <v-divider class="mx-4"></v-divider> -->
    <v-card-text class="mt-5">
      <v-row v-for="(item, index) in data" :key="index" class="align-center" no-gutters>
        <v-col cols="6" class="text-left">
          {{item.name}}
        </v-col>
        <v-col cols="6" class="text-right">
          <v-chip v-if="item.colored1" :color="parseFloat(item.line1) >= 0 ? '#28A745' : '#DC3545'" outlined small>
            <p v-if="item.line1" class="text-subtitle-2 font-weight-bold ma-0 pa-0 lineheight">{{item.line1}}</p>
          </v-chip>
          <p v-else class="text-subtitle-2 font-weight-bold ma-0 pa-0 lineheight">{{item.line1}}</p>
          <v-chip v-if="item.colored2" :color="parseFloat(item.line2) >= 0 ? '#28A745' : '#DC3545'" outlined small>
            <p v-if="item.line2" class="text-body-2 ma-0 pa-0 lineheight">{{item.line2}}</p>
          </v-chip>
          <p v-else class="text-body-2 ma-0 pa-0 lineheight">{{item.line2}}</p>


          <!-- <p v-if="item.line1" class="text-subtitle-1 font-weight-bold ma-0 pa-0 lineheight" color="green">{{item.line1}}</p> -->
          <!-- <p v-if="item.line2" class="text-body-2 ma-0 pa-0 lineheight">{{item.line2}}</p> -->
          <!-- :color="parseFloat(item.valueETH) >= 0 ? '#28A745' : '#DC3545'" -->
          <!-- <v-row v-if="item.line1" class="green justify-right align-center text-right align-end">
              {{item.line1}}
          </v-row>
          <v-row v-if="item.line2" class="justify-right blue">
            {{item.line2}}
          </v-row> -->
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
    props: [
      'title', 'subtitle', 'data', 'fullheight'
    ]
  }
</script>

<style lang="css">
  .factor {
    font-size: 1.50em !important;
    font-weight: bold;
    color: green;
    text-shadow: 0px 0px 5px green;
  }
  .lineheight {
    line-height: 1 !important;
  }
</style>
